import { render, staticRenderFns } from "./VerDetalleAlerta.vue?vue&type=template&id=0a0bc8fa&"
import script from "./VerDetalleAlerta.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleAlerta.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0a0bc8fa', component.options)
    } else {
      api.reload('0a0bc8fa', component.options)
    }
    module.hot.accept("./VerDetalleAlerta.vue?vue&type=template&id=0a0bc8fa&", function () {
      api.rerender('0a0bc8fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Camaras/Alertas/VerDetalleAlerta.vue"
export default component.exports